import {Paper, Typography} from '@mui/material';

export interface SessionCompleteMessageProps {
  score: number;
}

export default function SessionCompleteMessage({score}: SessionCompleteMessageProps) {
  const getPerformanceMessage = (scoreNumber: number) => {
    if (scoreNumber >= 90) return "Excellent work! You're mastering this topic.";
    if (scoreNumber >= 80) return 'Great job! You have a solid understanding.';
    if (scoreNumber >= 70) return 'Good effort! Keep practicing to improve.';
    if (scoreNumber >= 60) return 'Not bad! Review the topics and try again.';
    return 'Keep practicing! Review the explanations and try again.';
  };

  return (
    <Paper sx={{p: 3, bgcolor: 'grey.50'}}>
      <Typography variant="body1" sx={{textAlign: 'center', fontStyle: 'italic'}}>
        {getPerformanceMessage(score)}
      </Typography>
    </Paper>
  );
}
